import React from 'react';
import { useEditMode } from '../context/EditModeContext';

/**
 * HrefPill
 * --------------------------------------------------------------------
 * Small editor-only input that sits next to a link/button so admins can
 * edit the href / URL string that isn't otherwise visible.
 *
 * Renders nothing in view mode. In edit mode renders a yellow pill
 * input bound to `value` with the supplied `onChange(nextHref)`.
 */
function HrefPill({ value, onChange, placeholder = 'href' }) {
  const { editMode } = useEditMode();
  if (!editMode) return null;
  return (
    <input
      type="text"
      value={value || ''}
      onChange={(e) => onChange && onChange(e.target.value)}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      className="block mt-1 text-[10px] bg-yellow-50 border border-yellow-300 px-2 py-0.5 rounded w-full max-w-xs text-ink/80 font-mono"
      placeholder={placeholder}
    />
  );
}

export default HrefPill;
